import { render, staticRenderFns } from "./PostFinished.vue?vue&type=template&id=73cba5b6"
import script from "./PostFinished.vue?vue&type=script&lang=js"
export * from "./PostFinished.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports